module.exports = __webpack_public_path__ + "static/media/Regulador-02.f89158d5.jpg";